import { Link } from 'react-router-dom';

export default function TermsOfUseProPage() {
  return (
    <div className="legal-page min-h-screen bg-gray-50 py-8">
      <div className="max-w-3xl mx-auto px-4">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/volovolo.png"
            alt="Volovolo"
            className="h-20 w-auto mx-auto"
          />
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-2xl font-bold mb-6">
            Conditions Generales d'Utilisation (CGU) de volovolo.pro
          </h1>

          {/* 1. Definitions */}
          <h2 className="text-xl font-bold mt-6 mb-4">1. Definitions</h2>
          <p className="text-gray-700 mb-4">
            Inclure une definition des acteurs, incluant volovolo.pro, Vendeur, Acheteur,
            Utilisateur, ainsi que les partenaires de paiement (Stripe).
          </p>

          {/* 2. Objet */}
          <h2 className="text-xl font-bold mt-8 mb-4">2. Objet</h2>
          <p className="text-gray-700 mb-4">
            Preciser que les CGU definissent egalement les obligations legales des vendeurs,
            incluant la conformite des produits, le respect des lois fiscales et douanieres.
          </p>

          {/* 3. Role de la plateforme */}
          <h2 className="text-xl font-bold mt-8 mb-4">3. Role de la plateforme</h2>
          <p className="text-gray-700 mb-4">
            volovolo.pro agit comme intermediaire technique et financier, n'est pas partie
            au contrat de vente, mais assure le role d'encaissement et de securisation des
            paiements pour le compte des vendeurs.
          </p>

          {/* 4. Modalites d'inscription */}
          <h2 className="text-xl font-bold mt-8 mb-4">
            4. Modalites d'inscription, acces, obligations et sanctions
          </h2>
          <ul className="list-disc ml-6 space-y-2 text-gray-700 mb-4">
            <li>
              Obligation pour le vendeur de fournir des informations exactes et conformes a la loi.
            </li>
            <li>
              Engagement a ne pas utiliser la plateforme a des fins illegales, de fraude,
              de spam ou de violation des droits des tiers.
            </li>
            <li>
              volovolo.pro se reserve le droit de suspendre ou supprimer un compte sans
              preavis en cas de non-respect des CGU, fraude ou non-conformite legale.
            </li>
            <li>
              Le vendeur accepte d'etre audite et que ses donnees soient examinees en cas
              de suspicion de fraude.
            </li>
          </ul>

          {/* 5. Propriete intellectuelle */}
          <h2 className="text-xl font-bold mt-8 mb-4">5. Propriete intellectuelle</h2>
          <p className="text-gray-700 mb-4">
            Le vendeur reste proprietaire de ses contenus mais accorde une licence mondiale,
            gratuite et transferable a volovolo.pro pour l'exploitation necessaire au
            fonctionnement et a la promotion de la plateforme.
          </p>

          {/* 6. Paiement */}
          <h2 className="text-xl font-bold mt-8 mb-4">6. Paiement et role de l'intermediaire</h2>
          <ul className="list-disc ml-6 space-y-2 text-gray-700 mb-4">
            <li>
              Les paiements sont traites via Stripe, avec conservation jusqu'a confirmation
              de reception par l'acheteur.
            </li>
            <li>Les frais Stripe sont independants de volovolo.pro.</li>
            <li>En cas de remboursement, celui-ci est effectue apres restitution du produit.</li>
            <li>
              Le vendeur reste responsable des obligations legales de garantie et de conformite.
            </li>
          </ul>

          {/* 7. Commissions */}
          <h2 className="text-xl font-bold mt-8 mb-4">7. Commissions et abonnements</h2>
          <p className="text-gray-700 mb-2">Des frais de commission sont appliques :</p>
          <ul className="list-disc ml-6 space-y-2 text-gray-700 mb-2">
            <li>10% pour les vendeurs ayant un compte gratuit (Formule Basic).</li>
            <li>
              4% pour les vendeurs avec abonnement Premium, incluant mise en avant, outils
              avances, statistiques, support prioritaire.
            </li>
            <li>
              Certaines formules incluent campagnes de promotion, acces aux ventes en live,
              et gestion multi-boutiques.
            </li>
          </ul>
          <p className="text-gray-700 mb-4">
            Ces abonnements permettent de reduire les frais et d'optimiser la visibilite
            des vendeurs sur volovolo.pro.
          </p>

          {/* 8. Responsabilites */}
          <h2 className="text-xl font-bold mt-8 mb-4">8. Responsabilites</h2>
          <ul className="list-disc ml-6 space-y-2 text-gray-700 mb-4">
            <li>
              volovolo.pro decline toute responsabilite sur la qualite des produits, la
              livraison ou le respect des obligations entre vendeur et acheteur.
            </li>
            <li>
              Le vendeur est responsable des informations fournies, des litiges, de la
              gestion des retours, et du respect des obligations legales.
            </li>
          </ul>

          {/* 9. Limitation de responsabilite */}
          <h2 className="text-xl font-bold mt-8 mb-4">9. Limitation de responsabilite</h2>
          <p className="text-gray-700 mb-4">
            volovolo.pro ne garantit pas un fonctionnement sans erreur de la plateforme
            et decline toute responsabilite pour les interruptions, pertes de donnees ou
            prejudices indirects.
          </p>

          {/* 10. Confidentialite */}
          <h2 className="text-xl font-bold mt-8 mb-4">10. Confidentialite et donnees personnelles</h2>
          <ul className="list-disc ml-6 space-y-2 text-gray-700 mb-4">
            <li>Les utilisateurs s'engagent a respecter la politique de confidentialite.</li>
            <li>volovolo.pro s'engage a traiter les donnees conformement au RGPD.</li>
            <li>
              Notifications importantes envoyees par mail ou via l'interface utilisateur.
            </li>
          </ul>

          {/* 11. Mediation */}
          <h2 className="text-xl font-bold mt-8 mb-4">11. Mediation et litiges</h2>
          <p className="text-gray-700 mb-4">
            En cas de litige, le service client peut etre contacte pour resolution amiable.
            Possibilite de recours a un mediateur conformement aux obligations legales.
          </p>

          {/* 12. Droit applicable */}
          <h2 className="text-xl font-bold mt-8 mb-4">12. Droit applicable et juridiction competente</h2>
          <p className="text-gray-700 mb-4">
            Les presentes CGU sont regies par le droit francais. Tout litige sera porte
            devant les tribunaux competents du siege social de volovolo.pro, sauf
            dispositions legales contraires.
          </p>

          {/* Footer Links */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex flex-wrap gap-4 text-sm text-gray-600">
              <Link to="/privacy-policy/pro" className="text-cyan-600 hover:underline">
                Politique de Confidentialite
              </Link>
              <Link to="/cgv/pro" className="text-cyan-600 hover:underline">
                Conditions Generales de Vente
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
